// extracted by mini-css-extract-plugin
module.exports = {"container":"CommitteeDetailsCard_container__3hPEd","cardHeader":"CommitteeDetailsCard_cardHeader__2yHAP"};